var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2H35.5C36.88 2 38 3.12 38 4.5V35.5C38 36.88 36.88 38 35.5 38H4.5C3.12 38 2 36.88 2 35.5V4.5C2 3.12 3.12 2 4.5 2ZM34 34V6H6V34H34ZM20 12C20 9.8 18.2 8 16 8C13.8 8 12 9.8 12 12C12 14.2 13.8 16 16 16C18.2 16 20 14.2 20 12ZM26 22C26 22 26 10 32 10V30C32 31.1 31.1 32 30 32H10C8.9 32 8 31.1 8 30V16C12 16 14 24 14 24C14 24 16 18 20 18C24 18 26 22 26 22Z",
    fill: "#8BAEC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.d8a656caef2322cad231d157ccd79be1.svg";
export { ForwardRef as ReactComponent };